// Promise Polyfill
import 'es6-promise/auto';
import { ApolloProvider } from '@apollo/client';
import { Notification } from '@perch-labs/shrike';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { LDClient, LDProvider, QueryParamsProvider, LocalizeProvider } from '~/providers';
import { initializeTracking } from '~/utils/tracking';
import { apolloClient } from './apollo-client';
import { App, Token } from './app';
import { GlobalStyles } from './styles';
import '@perch-labs/shrike/dist/shrike.css';
import { getTheme } from './styles/theme';
import { isPerch, ORGANIZATION_ENTITIES } from './utils/constants';

initializeTracking();
const entity = isPerch() ? ORGANIZATION_ENTITIES.PERCH : ORGANIZATION_ENTITIES.ARCADIA;
ReactDOM.render(
  <LDProvider client={LDClient}>
    <ThemeProvider theme={getTheme(entity)}>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <Token>
            <QueryParamsProvider>
              <Notification.Provider>
                <LocalizeProvider>
                  <App />
                </LocalizeProvider>
                <GlobalStyles />
              </Notification.Provider>
            </QueryParamsProvider>
          </Token>
        </BrowserRouter>
      </ApolloProvider>
    </ThemeProvider>
  </LDProvider>,
  document.getElementById('app'),
);
